import { render } from "./KioskWaitPage.vue?vue&type=template&id=2f252d60&scoped=true"
import script from "./KioskWaitPage.vue?vue&type=script&lang=js"
export * from "./KioskWaitPage.vue?vue&type=script&lang=js"

import "./KioskWaitPage.vue?vue&type=style&index=0&id=2f252d60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f252d60"]])

export default __exports__